import type { ReactNode } from "react";

export interface InfoPairProps {
    title: string;
    value?: string | number;
    ellipsis?: boolean;
    tip?: string;
    direction?: "row" | "column";
    children?: ReactNode;
}

/** 信息键值对，保留旧版行/列方向和缺省值显示。 */
export function InfoPair({ title, value, ellipsis = false, tip, direction = "column", children }: InfoPairProps) {
    const displayValue = value === "" || value === null || value === undefined ? "--" : value;
    return (
        <div className={`info-pair ${direction}`}>
            <div className="info-pair--title">
                {title}
                {tip ? <small>{tip}</small> : null}
            </div>
            <div className={ellipsis ? "info-pair--value ellipsis" : "info-pair--value"}>
                {children ?? displayValue}
            </div>
        </div>
    );
}

export default InfoPair;
